<template>
  <v-container>
    <!-- <v-layout justify-space-between>
      <h1>New Fixed Cost Trip</h1>
    </v-layout>-->
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8>
        <SimpleCard>
          <v-layout justify-start align-content-start row wrap>
            <v-flex xs12>
              <h4>Invoicing Settings</h4>
            </v-flex>
            <v-flex xs6>
              <v-row align="center">
                <v-flex pr-2>
                  <v-currency-field
                    type="number"
                    v-model="maximumAdditionalCharge"
                    label="Maximum Additional Charge"
                    v-bind="currency_config"
                    min="0"
                  ></v-currency-field>
                </v-flex>
                <v-btn @click="updateMaximumAdditionalCharge" small>Update</v-btn>
              </v-row>
            </v-flex>
          </v-layout>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

import qs from "qs";

export default {
  name: "fixed_pricing",
  components: {
    Overview,
    SimpleCard
  },
  data: function() {
    return {
      loading: false,
      maximumAdditionalCharge: null,
      currency_config: {
        decimal: ".",
        prefix: "£",
        precision: 2,
        masked: false,
        allowBlank: true
      }
    };
  },
  mounted: async function() {
    this.getInvoicingSettings();
  },
  methods: {
    getInvoicingSettings: function(p) {
      this.loading = true;

      var url = `${this.$store.state.apiUrl}/invoicing/settings/get`;

      var vm = this;

      axios({
        url: url,
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            vm.maximumAdditionalCharge = res.data.maximumAdditionalCharge / 100;
          } else {
            alert("Failed to get settings");
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
          console.error(err);
        });
    },
    updateMaximumAdditionalCharge: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${
        this.$store.state.apiUrl
      }/invoicing/settings/maximumAdditionalCharge?maximumAdditionalCharge=${Math.round(
        this.maximumAdditionalCharge * 100
      )} `;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: qs.stringify(p),
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            alert("Maximum additional charge updated");
          } else {
            alert(
              "Maximum additional charge failed to update: " +
                res.data.error.message
            );
          }
        })
        .catch(function(err) {
          alert("Internal Server Error");
        });
    }
  }
};
</script>
